import React, { Component } from 'react';
import ApiService from '../../service/ApiService';
//import { convertToInternationalCurrencySystem } from '../../service/Util';
import { Link } from 'react-router-dom';

class PrePostStockPrice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            symbolName: this.props.symbolName,
            ticker: this.props.ticker,
            bgc: this.props.bgc,
            interval: '1min',
            show: false
        };
    }

    componentDidMount() {
        console.log('PrePostStockPrice', this.state.ticker);
        this.getData();
        this.interval = setInterval(() => { this.getData() }, 1000 * 10 * 1); //1 mins
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    getData() {
        ApiService.getQuotes(this.state.ticker)
            .then(result => {
                console.log('getQuotes Data', result);
                if (result !== undefined && result.length > 0) {
                    let previousClose = result[0].price;

                    ApiService.getPrePostStock(this.state.ticker, this.state.interval, null, null)
                        .then(result => {
                            console.log('PrePostStockPrice Data', result);
                            if (result !== undefined && result.results !== undefined & result.results.length > 0) {
                                let resData = result.results;
                                let close = resData[resData.length - 1].c;
                                let percent = (close - previousClose) / previousClose * 100;
                                this.setState({
                                    price: close,
                                    change: close - previousClose,
                                    changesPercentage: percent,
                                    volume: resData[resData.length - 1].v,
                                    show: true
                                });

                            } else {
                                this.setState({
                                    price: 0,
                                    change: 0,
                                    changesPercentage: 0,
                                    volume: 0,
                                    show: false
                                });
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    render() {
        return (
            <>
                <div style={{backgroundColor: this.state.bgc}}>
                    <Link style={{ fontSize: "12px", fontWeight: 'bold', color: parseFloat(this.state.change) >= 0 ? 'green' : 'red' }} to={'/chart/' + this.state.ticker}>{this.state.symbolName}</Link>
                </div>
                {this.state.show ? (
                    <div style={{ fontSize: '10px', fontWeight: 'bold', backgroundColor: this.state.bgc, color: parseFloat(this.state.change) >= 0 ? 'green' : 'red' }}>
                        {parseFloat(this.state.price).toFixed(2)}&nbsp;&nbsp;&nbsp;
                        {parseFloat(this.state.change).toFixed(2)}&nbsp;
                        ({parseFloat(this.state.changesPercentage).toFixed(2)}%)
                    </div>
                ) : (
                    <div style={{backgroundColor: this.state.bgc}}>
                        <i className={'fa fa-spinner fa-pulse'} ></i>
                    </div>
                )}
            </>
        );

    }
}

export default PrePostStockPrice;
